// Add your custom JS here.
jQuery(document).ready(function ($) {
    dayjs.extend(window.dayjs_plugin_isBetween);
    const $homeWrapper = $('#home-wrapper');

    if($homeWrapper.length !== 0){
        /* Sticky */
        const $calendarContainer = $('.calendar-container');
        const $calendar = $('.calendar');
        const $listEvent = $('.list-events');
        const $description = $('.description'); // for md -xl
        const $descriptionImage = $('.description .left-column'); // for < xl
        const $descriptionText = $('.description .text'); // for < xl

        let listEventTop = $listEvent.offset().top;
        let homeWrapperTop = $homeWrapper.offset().top;
        let calendarTextHeight = $calendar.offset().top - $calendarContainer.offset().top;
        let calendarTop = homeWrapperTop;

        const isMobile = window.matchMedia("(max-width: 767px)").matches;

        if(isMobile){
            calendarTop = homeWrapperTop - calendarTextHeight;
        }

        $calendarContainer.css('top', calendarTop + 'px');
        $description.css('top', listEventTop + 'px');
        $descriptionImage.css('top', listEventTop + 'px');
        $descriptionText.css('top', listEventTop + 'px');

        /* Calendar */
        dayjs.locale('es');
        const swiperWrapper = document.querySelector('.calendar-swiper .swiper-wrapper');
        const currentMonthLabel = document.querySelector('.current-month');
        const nextMonthLabel = document.querySelector('.next-month');
        const prevBtn = document.querySelector('.previous-month');
        const nextBtn = document.querySelector('.next-month');

        // month of the URL or current month
        const url = new URL(window.location.href);
        let daySelected = url.searchParams.get('dia') || '';
        let currentMonth = daySelected ? dayjs(daySelected, 'YYYYMMDD') : dayjs();
        let swiper;

        /* Initialize Swiper */
        function initSwiper(initialIndex = 0) {
            if (swiper) swiper.destroy(true, true);

            swiper = new Swiper('.calendar-swiper', {
                slidesPerView: 'auto',
                //spaceBetween: 12,
                resistance: true,
                resistanceRatio: 0,
                on: {
                    init: function () {
                        this.slideTo(initialIndex, 0); //Active slide on initialization
                    },
                    transitionEnd: function() {
                        //Prevent partial slide on init
                        if (!this.swipeDirection) {
                            const swiperWrapper = document.querySelector('.calendar-swiper');
                            let activeSlide = this.slides[this.activeIndex];

                            if (activeSlide && swiperWrapper) {
                                let swiperWrapperLeft = swiperWrapper.getBoundingClientRect().left;
                                let activeSlideLeft = activeSlide.getBoundingClientRect().left;

                                //If the first slider doesn't go in completely, we move on to the next one.
                                if (swiperWrapperLeft > activeSlideLeft) {

                                    let newActiveIndex = this.activeIndex + 1;
                                    // assign a new index
                                    if (this.slides[newActiveIndex]) {
                                        this.activeIndex = newActiveIndex;
                                        this.updateActiveIndex();
                                        this.updateSlidesClasses();

                                        // move the slider to the new active item
                                        this.setTranslate(-this.slides[newActiveIndex].offsetLeft);
                                    }
                                } else {
                                    this.setTranslate(-activeSlide.offsetLeft);
                                }
                            }
                        }
                    }
                }
            });
        }

        function getEventDatesByMonth($month = ''){
            return $.ajax({
                url: admin_url.ajax_url,
                type: 'POST',
                data: {
                    action: 'getEventDatesByMonthAjax',
                    month: $month,
                }
            })
            .then(function(response) {
                let allDates = [];
                if (response.dates) {
                    const ranges = response.dates || [];
                    const expandedDays = [];

                    // convert ranges into days
                    ranges.forEach(range => {
                        let current = dayjs(range['from-date']);
                        const end = dayjs(range['to-date']);

                        while (current.isBefore(end) || current.isSame(end, 'day')) {
                            expandedDays.push(current.format('YYYYMMDD'));
                            current = current.add(1, 'day');
                        }
                    });

                    allDates = [...new Set(expandedDays)];
                }
                return allDates;
            });
        }

        /* Display the days of a month on the slider - slide per day*/
        async function renderMonth(currentMonth, initialLoad = false) {
            swiperWrapper.innerHTML = ''; // delete the previous month if exists.
            const month = currentMonth.format('YYYYMM');

            // last selected day if exist in url
            const url = new URL(window.location.href);
            let daySelected = url.searchParams.get('dia') || '';

            const daysEvent = new Set(await getEventDatesByMonth(month));
            const daysInMonth = currentMonth.daysInMonth();
            let initialIndex = 0;

            for (let i = 1; i <= daysInMonth; i++) {
                const date = currentMonth.date(i);
                const dateFormat = date.format('YYYYMMDD');

                const hasEvent = daysEvent.has(dateFormat); // if the date has an event
                const isSelected = daySelected === dateFormat; // if the date exists in the URL

                // HTML creation
                const slide = document.createElement('div');
                slide.className = 'swiper-slide' + (hasEvent ? ' has-event' : '') + (isSelected ? ' day-selected' : '');
                slide.dataset.date = dateFormat;
                const innerDiv = document.createElement('div');
                innerDiv.className = 'day';
                innerDiv.textContent = i;

                slide.appendChild(innerDiv);
                swiperWrapper.appendChild(slide);

                // initial slide assignment
                if ((initialLoad && isSelected) || (initialLoad && date.isSame(dayjs(), 'day') && !isSelected)) {
                    initialIndex = i - 1;
                }
            }

            currentMonthLabel.textContent = currentMonth.format('MMMM YYYY');
            nextMonthLabel.textContent = currentMonth.add(1, 'month').format('MMMM YYYY');

            initSwiper(initialLoad ? initialIndex : 0);
        }

        /* Load previous month */
        prevBtn.addEventListener('click', () => {
            currentMonth = currentMonth.subtract(1, 'month');
            renderMonth(currentMonth, false);
        });

        /* Load next month */
        nextBtn.addEventListener('click', () => {
            currentMonth = currentMonth.add(1, 'month');
            renderMonth(currentMonth, false);
        });

        /* Initial load, current month */
        renderMonth(currentMonth, true);


        /* show more - main list and calendar */
        $('#show-more-events-js').on('click', function () {
            const url = new URL(window.location.href);
            let page = parseInt(url.searchParams.get('pg')) || 1;
            page++;
            let calendarDate = url.searchParams.get('dia') || '';

            $.ajax({
                url: admin_url.ajax_url,
                type: 'POST',
                data: {
                    action: 'getEventsAjax',
                    date: calendarDate,
                    page: page
                }
            })
            .done(function(response) {
                if (response.events) {
                    $('#events-container-js').append(response.events);
                    url.searchParams.set('pg', page);
                    history.pushState({}, "", url);
                }
                if (!response.hasMorePages) {
                    $('#show-more-events-js').addClass('d-none');
                } else {
                    $('#show-more-events-js').removeClass('d-none');
                }
            })
        });

        /* Calendar - day event load */
        $(document).on('click', '.calendar-swiper .swiper-slide', function () {
            if ($(this).hasClass('has-event')) {
                const calendarDate = $(this).data('date');
                const $eventsContainer = $('#events-container-js');
                const $allSlides = $('.calendar-swiper .swiper-slide');
                let page = 1;

                /* Removed possible initial pagination. */
                const url = new URL(window.location.href);
                url.searchParams.delete('pg');
                url.searchParams.set('dia', calendarDate);
                history.pushState({}, "", url);

                $allSlides.removeClass('day-selected');
                $(this).addClass('day-selected');

                $.ajax({
                    url: admin_url.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'getEventsAjax',
                        date: calendarDate,
                        page: page
                    }
                })
                .done(function(response) {
                    if (response.events) {
                        $eventsContainer.html(response.events);
                    }
                    if (!response.hasMorePages) {
                        $('#show-more-events-js').addClass('d-none');
                    } else {
                        $('#show-more-events-js').removeClass('d-none');
                    }
                });
            }
        });
    }
});

/* If we click back in the browser, we clear the URL and reload it.*/
window.onpopstate = function() {
    window.location.reload();
};